import { useExperiments } from "./useExperiments.js";
export function useExperimentValue(experimentName, { defaultValue }) {
  const variation = useExperiments()[experimentName];
  if (!variation || variation === "noVariation") return defaultValue;
  return variation;
}
